<template>
  <v-dialog v-model="show" :max-width="maxWidth" :persistent="persistent">
    <v-card>
      <v-layout column justify-center>
        <v-card-title class="headline" primary-title>
          <span>
            {{ title }}
          </span>
        </v-card-title>

        <v-divider class="ma-0"></v-divider>

        <v-card-text>
          <p class="text-xs-center">{{ description }}</p>
        </v-card-text>

        <v-divider class="ma-0"></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="cancelColor" flat dark @click="onCancel">
            {{ cancelText }}
          </v-btn>
          <v-btn :color="confirmColor" dark @click="onConfirm">
            {{ confirmText }}
          </v-btn>
        </v-card-actions>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    confirmText: {
      type: String,
      default: "Sim",
    },
    cancelText: {
      type: String,
      default: "Não",
    },
    confirmColor: {
      type: String,
      default: "primary",
    },
    cancelColor: {
      type: String,
      default: "primary",
    },
    maxWidth: {
      type: String,
      default: "500px",
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    onConfirm() {
      this.$emit("confirm");
      this.show = false;
    },
    onCancel() {
      this.$emit("cancel");
      this.show = false;
    },
  },
};
</script>
